import type { SyntheticEvent, FC } from 'react';
import { Box, ListItem } from '@chakra-ui/react';

import { Customer } from 'types/customer';
import { ListSkeleton } from 'components/molecules/ListSkeleton';
import { ListView } from 'components/molecules/ListView';

import { CustomerListHeader } from './CustomerListHeader';
import { CustomerListItem } from './CustomerListItem';

type Props = {
  loading: boolean;
  customers: Customer[];
  validateSafetyPoseidonUrl: (url: string) => boolean;
  handleClickCustomer: (customer: Customer) => void;
  handleClickCustomerPoseidonLinkButton: (
    e: SyntheticEvent<HTMLButtonElement>,
    url: string,
  ) => void;
};

export const CustomerListView: FC<Props> = ({
  loading,
  customers,
  validateSafetyPoseidonUrl,
  handleClickCustomer,
  handleClickCustomerPoseidonLinkButton,
}) => {
  if (loading) {
    return <ListSkeleton />;
  }

  return (
    <>
      {/* 顧客一覧のヘッダ */}
      <Box m="20px 0 0 0">
        <CustomerListHeader />
      </Box>
      {/* 顧客一覧 */}
      <ListView>
        {customers.map((item) => (
          <ListItem key={item.id} listStyleType="none">
            <CustomerListItem
              item={item}
              disableCustomerPoseidonLinkButton={
                !validateSafetyPoseidonUrl(item.poseidon_url)
              }
              handleClickCustomer={() => handleClickCustomer(item)}
              handleClickCustomerPoseidonLinkButton={(e) =>
                handleClickCustomerPoseidonLinkButton(e, item.poseidon_url)
              }
            />
          </ListItem>
        ))}
      </ListView>
    </>
  );
};
